import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableRow, Modal, Header } from 'semantic-ui-react';
import getUnapprovedCompanyRecruiters from '../../../../../services/getUnapprovedCompanyRecruiters';
import Button from '../../../../../components/Button';
import  CompanyDropdown  from '../../../../../components/Dropdown/CompanyDropdown';
import updateCompanyId from '../../../../../services/updateCompanyId';
import { getValueFromRecruiterType } from '../../../../../models/recruiterType';
import { toast } from 'react-toastify';
import './CompanyStyles.scss';

const notAvailable = 'N/A';

const CompanySingleList = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [isViewingRecruiters, setIsViewingRecruiters] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({id: props.data.id, name: props.data.name});
    const [recruiters, setRecruiters] = useState({ iimjobs: [], hirist: [] });
    const [submitLoading, setSubmitLoading] = useState(false);
    
    const companyId = props.data.id;

    const onVerifyClick = async() => {
        const list = await fetchRecruiters(companyId);
        if (!list) {
            return; 
        }
        setRecruiters(list);
        if(list && (list.iimjobs.length || list.hirist.length) > 0) {
            setIsVerifying(true);
            setModalOpen(true);
        } else {
            const userConfirm = confirm('Are you sure you want to perform this action?');
            if (userConfirm) {
                props.changeStatus();
            }
        }
    }
    const onViewRecruitersClick = async() => {
        const list = await fetchRecruiters(companyId);
        if(!list) {
            return; 
        }
        setRecruiters(list);
        setIsViewingRecruiters(true);
        setModalOpen(true);
    };

    const onRejectClick = async() => {
        const list = await fetchRecruiters(companyId);
        if (!list) {
            return; 
        }
        setRecruiters(list);
        if(list && (list.iimjobs.length || list.hirist.length) > 0) {
            setModalOpen(true);
        } else {
            const userConfirm = confirm('Are you sure you want to perform this action?');
            if (userConfirm) {
                props.rejectCompany();
            }
        }
    }
    const fetchRecruiters = async (companyId) => {
        try {
            const recruitersList = await getUnapprovedCompanyRecruiters(props.adminId, {companyId});
            return recruitersList.data.data;
        } catch (error) {
            console.error('Failed to fetch recruiters:', error);
            toast.error('Failed to fetch recruiters data');
            return null;
        }
    }; 
    const handleModalClose = () => {
        setModalOpen(false);
        setIsViewingRecruiters(false);
        setIsVerifying(false);
    };
    const handleModalSubmit = async () => {
        try {
            setSubmitLoading(true);
            if (isVerifying) {
                props.changeStatus();
                handleModalClose();
                return;
            }

            if(selectedCompany.id==companyId) {
                toast.error('Select a different company');
                setSubmitLoading(false);
                return;
            }

            const recruiterIds = {
                iimjobs: recruiters.iimjobs.map((recruiter) => recruiter.id),
                hirist: recruiters.hirist.map((recruiter) => recruiter.id),
            };
            await updateCompanyId(props.adminId, {companyId:selectedCompany.id, recruiterIds,adminEmail:props.adminEmail});
            toast.success('Recruiters mapped successfully');
            props.changeStatus();
            setSubmitLoading(false);
            handleModalClose();
        } catch(err){
            console.error('Failed to map recruiters to company',err);
            toast.error('Failed to map recruiters to company');
            setSubmitLoading(false);
            handleModalClose();
        }
    };
    
    return (
        <>
        <TableRow>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.id ? props.data.id : notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {(props.data.domains || []).join(',')}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.name ? props.data.name : notAvailable}
            </Table.Cell>

            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.displayName ? props.data.displayName : notAvailable}
            </Table.Cell>

            <Table.Cell className="managementData" verticalAlign="top">
                {Number(props.data.type)
                    ? getValueFromRecruiterType(props.data.type)
                    : notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.industry
                    ? props.industryData[props.data.industry]
                    : notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.infoedgeId ? props.data.infoedgeId : notAvailable}
            </Table.Cell>
            <Table.Cell className="managementData" verticalAlign="top">
                {props.data.moderated ? 'true' : 'false'}
            </Table.Cell>
            {props.executeAccess ? (
                <Table.Cell className="managementData actions" verticalAlign="top">
                    {
                        <Button
                        skin="dark"
                        text="View Recruiters"
                        clickButton={onViewRecruitersClick}
                        className="buttonMargin"
                    />
                    }
                    {props.data.status == 2 && (
                        <Button
                            skin="dark"
                            text="Verify"
                            clickButton={onVerifyClick}
                            className="buttonMargin"
                        />
                    ) }
                    
                    {props.data.status == 2 && (
                        <Button
                            skin="dark"
                            text="Reject"
                            clickButton={onRejectClick}
                            className="buttonMargin"
                        />
                    ) }
                    <Button
                        skin="dark"
                        text="Edit"
                        clickButton={props.onClick}
                        className="buttonMargin"
                    />
                </Table.Cell>
            ) : null}
        </TableRow>

        <Modal open={modalOpen} onClose={handleModalClose} size="">
        {recruiters && (
            <>
                <Header content={props.data.name} />
                {(
                    <>
                        <Modal.Content scrolling>
                        {!isViewingRecruiters && !isVerifying && (
                            <div className="companyDropdown">
                                <div>Select the new company to map the recruiters: </div>
                                    <CompanyDropdown
                                        adminId={props.adminId}
                                        selectedCompany={selectedCompany.name}
                                        onCompanySelect={(id, label) => setSelectedCompany({id, name: label})}
                                    />
                            </div>
                        )}
                            {recruiters.iimjobs.length > 0 && (
                                <Table fixed selectable >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan='4' >IIMJOBS</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell width={3}>Recruiter Id</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                                            <Table.HeaderCell width={5}>Email</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Recruiter Status</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {(recruiters.iimjobs).map((recruiter) => (
                                            <Table.Row key={recruiter.id}>
                                                <Table.Cell>{recruiter.id}</Table.Cell>
                                                <Table.Cell>{recruiter.recname}</Table.Cell>
                                                <Table.Cell>{recruiter.email}</Table.Cell>
                                                <Table.Cell>{recruiter.status==1?'Active':'Inactive'}</Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}

                            {recruiters.hirist.length > 0 && (
                                <Table fixed selectable>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan='4'>HIRIST</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell width={3}>Recruiter Id</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                                            <Table.HeaderCell width={5}>Email</Table.HeaderCell>
                                            <Table.HeaderCell width={4}>Recruiter Status</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {(recruiters.hirist).map((recruiter) => (
                                            <Table.Row key={recruiter.id}>
                                                <Table.Cell>{recruiter.id}</Table.Cell>
                                                <Table.Cell>{recruiter.recname}</Table.Cell>
                                                <Table.Cell>{recruiter.email}</Table.Cell>
                                                <Table.Cell>{recruiter.status==1?'Active':'Inactive'}</Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table>
                            )}
                        </Modal.Content>
                        <Modal.Actions>
                            {(isVerifying || !isViewingRecruiters) && (
                                <Button
                                    clickButton={handleModalSubmit}
                                    skin="light"
                                    text="Submit"
                                    loading={submitLoading}
                                />
                            )}
                            <Button
                                clickButton={handleModalClose}
                                skin="light"
                                text="Close"
                            />
                        </Modal.Actions>
                    </>
                )}
            </>
        )}
        </Modal>
    </>
    );
};

CompanySingleList.propTypes = {
    data: PropTypes.object,
    industryData: PropTypes.array,
    executeAccess: PropTypes.bool,
    rejectCompany: PropTypes.func,
    openRecruitersModal: PropTypes.func,
    changeStatus: PropTypes.func,
    onClick: PropTypes.func,
    isRejectedStatus: PropTypes.bool,
    adminId: PropTypes.string.isRequired,
    adminEmail: PropTypes.string.isRequired,
};

export default CompanySingleList;
